<template>
  <div :class="['donutSection', 'donutSection-right', donut.id]">
    <div class="container">
        <div class="row">
            <div class="col-md-6">
                <div 
                    :style="`background-image : url(${donut.background_image_url});`"
                    class="donutImage">
                    <img :src="donut.side_image_url" :alt="donut.name">
                </div>
            </div>

            <div class="col-md-6">
                <div class="donutInfo">
                    <h1>{{donut.name}}</h1>
    
                    <p>{{donut.description}}</p>
                </div>
            </div>
    
        </div>
    </div>
</div>
</template>

<script>
export default {
    props : {
        donut : {
            type : Object,
            default : () => {
                return null;
            }
        }
    }
}
</script>

<style>

</style>